import React from "react";

import { Container, Row, Col } from "reactstrap";

function SwrccuHeader() {
  return (
    <div className="header">
      <Container>
        <Row>
          <Col className="mx-auto my-5 text-center" lg="10">
            <h1 className="display-2 text-default">
              South West Regional Cyber Crime Unit Leaders Conference
            </h1>
          </Col>
        </Row>
        <Row>
          <div className="floating-box rounded mx-3 bg-default">
            <h2 className="lead text-white p-5">
              On the 14th of September, we attended an inaugural South West Regional Cyber Crime 
              Unit &#40;SWRCCU&#41; Leaders Conference hosted by Somerset County Cricket Club in Taunton.
            </h2>
          </div>
        </Row>
      </Container>
    </div>
  );
}

export default SwrccuHeader;
